module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 159 50",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }